module.exports = __webpack_public_path__ + "img/981.d83ee061.jpg";